module.exports = __webpack_public_path__ + "static/media/program1.95c95e80.png";